<div class="main">
  <nf-app-container
    appTitle="Helios"
    appIconUrl="/helios/assets/HeliosLogo.svg"
  >
    <div class="content">
      <h1>Disable Ad Blocker</h1>
      <p>
        In order for Helios to perform at its best capacity, please have Ad
        Blocker disabled.
      </p>
    </div>
  </nf-app-container>
</div>
